import React from 'react'
import { Document } from '../../../../models/Document';
import { useSelector } from 'react-redux';
import { State } from '../../../../store';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import useMethodAccount from '../../../MyAccount/hooks/useMethodAccount';
import EAButton from '../../../shared/Buttons/EAButton';
import getId from '../../../../../utils/getId';
import { TbTicket } from 'react-icons/tb';
import { HiOutlineDocumentText } from 'react-icons/hi';
import EAAlert from '../../../shared/EAAlert';

interface IProps {
    document: Document;
}

const SingleDocument: React.FC<IProps> = ({document}) => {
    const logoUrl = useSelector((state: State) => state.config.facilityLogoUrl);
    const { t } = useTranslation();

    const {  getBoughtTickets, getDownloadDocument, loading, alert } = useMethodAccount();
  return (
    <div className="single-document__wrapper">
      <div className="single-document__left-column">
        <img className="single-document__logo" src={logoUrl} alt="Logo dokumenty" />

        <div className="single-document__info">
          <b className="text-color-dark">
            {document.documentNumber}{" "}
            {document.paymentStatus === "R" && (
              <span className="body-text-small text-color-error">({t("zwrocony")})</span>
            )}
          </b>
          <span className="body-text-small">{format(document.paymentDate, "dd.MM.yyyy")}</span>
          <span className="body-text-small">
            {document.total} {t("zl")}
          </span>
        </div>
      </div>

      <div className="single-document__right-column">
        <EAButton
          title={t("pobierz_dokument")}
          onClick={() => getDownloadDocument(getId(document))}
          startIcon={<HiOutlineDocumentText />}
          variant="outlined"
          fullWidth
          loading={loading}
        />
        {document.hasTickets && (
          <EAButton
            title={t("pobierz_bilety")}
            onClick={() => getBoughtTickets(getId(document))}
            startIcon={<TbTicket />}
            fullWidth
            loading={loading}
          />
        )}
      </div>
      {alert && <EAAlert type="error" message={alert} compact />}
    </div>
  );
}

export default SingleDocument